export const Nineteen = 'o';